import { RouterManager } from '@aclass/admin/managers';
import { UserStory } from '@aclass/admin/storage/actions';
import { IAclModuleState, IAdminState } from '@aclass/admin/storage/states';
import { BaseResolver } from '@aclass/core/resolvers/base.resolver';
import { NgRedux } from '@angular-redux/store';
import { Injectable } from '@angular/core';
import { filter, tap } from 'rxjs/operators';

@Injectable()
export class UserCreateStateResolver extends BaseResolver {

    static STOP_EVENT_NAME = 'stop:user-create';

    constructor(
        private ngRdx: NgRedux<IAdminState>,
        private routerManager: RouterManager
    ) {
        super();
        this.resolver = this.ngRdx.select<IAclModuleState['initialized']>(['aclModule', 'initialized']).pipe(
            filter(v => v),
            tap(() => this.ngRdx.dispatch(UserStory.dryRunCreatePage()))
        );
        this.employee = this.routerManager.onRejectNavigation(UserCreateStateResolver.STOP_EVENT_NAME);
    }

    /**
     * @inheritDoc
     */
    beforeResolve(): void {
    }
}
